// Staff RFID sign-in landing page (Session AFH). The email link points here with the raw token in
// the path (/staff-access/:token). We POST the token to validate it, which (on success) sets the
// standard session cookie server-side and returns the role-correct redirect; we then do a FULL
// navigation so the office or engineer shell boots fresh with the new cookie. Any failure renders a
// dark branded card with no reason detail (mirroring the portal verify failed state).
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../lib/api";
import { FullScreenLoader } from "../../components/Loader";

export function StaffAccessPage() {
  const { token = "" } = useParams();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!token) {
      setFailed(true);
      return;
    }
    let live = true;
    api.staffAccess
      .validate(token)
      .then((res) => {
        // A full navigation (not a client-side route change) so the office/engineer shell reloads
        // and picks up the new session cookie.
        if (live) window.location.assign(res.redirect);
      })
      .catch(() => {
        if (live) setFailed(true);
      });
    return () => {
      live = false;
    };
  }, [token]);

  if (!failed) return <FullScreenLoader />;

  return (
    <div className="flex min-h-dvh items-center justify-center bg-ele-bg px-4 text-ele-body">
      <div className="w-full max-w-md rounded-lg border border-ele-purple-accent bg-black/20 p-6 text-center">
        <h1 className="mb-2 font-heading text-2xl text-ele-white">This link cannot be used</h1>
        <p className="text-ele-body">Your sign-in link may have expired or already been used.</p>
      </div>
    </div>
  );
}
